/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=468811d0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=468811d0&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.30_typescript@4.9.5__webpack@5.105.4_esbuild@0.27.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__